import { Injectable } from '@angular/core';
import { BehaviorSubject, from, Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})

export class AutofocusService {
  private autoFocusedElements$ = new BehaviorSubject<{formId: string, formFieldId: number} | null>(null);

  setElementFocus(formId: string, formFieldId: number): void {
    this.autoFocusedElements$.next({formId, formFieldId})
  }

  getFocusedElementsObservable(): Observable< {formId: string, formFieldId: number} | null> {
    return this.autoFocusedElements$.asObservable();
  }
}
